import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/hanlin/poster_1'
  },
  {
    path: '/hanlin/:poster',
    name: 'Hanlin',
    component: () => import(/* webpackChunkName: "hanlin" */ '../views/Hanlin'),
    meta: {title: '和平翰林公馆', pathname: 'zhihu'}
  },
  {
		path: '/404',
		component: () => import(/* webpackChunkName: "404" */ '@/views/404'),
  },
  {
		path: '/*',
		redirect: '/404',
	}
]

const router = new VueRouter({
  routes
})

export default router
